<template>
  <div class="outerCtn">
    <img src="../../../assets/phoneCloseCM/banner1.png" alt="" width='100%'/>
    <div class="mytabs" :style="{top : hideHeight ? '0' : '280px'}">
        <div v-for="(item,index) in tabs" :key="item.key" :style="{color:item.isActive ? '#3170FF':'#FFF' , borderBottom:item.isActive ? '2px solid #3170FF' : 'none'}" @click="changeActive(index)">
            {{ item.name }}
        </div>
    </div>
    <div class="article" v-if="activeIndex == 0">
        <p>公司介绍</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div class="detail">
            <div>
                四川辰鳗科技有限公司（简称：辰鳗科技）成立于2020年，总部位于成都。 现已在南京、天津、北京、深圳、上海、杭州、重庆等地设有分支机构。
            </div>
            <div>
                辰鳗科技逐渐完善了云端的整体产品体系，持续为用户提供高性价落地性强的节能降碳方案。目前，已服务超25万家商户，200余家物业企业，包括万达、长城、嘉诚新悦等在内的百强物业客户20余家。
            </div>
            <div>
                辰鳗科技以智能终端为抓手，切入商业地产物业的商户经营和能源管理领域，为商业楼宇提供基于能源结构改造下的低碳、近零碳楼宇能源管理服务。地产物业客户不需要一次性采购投入，通过辰鳗经营管理、能源管理SaaS系统，进行订阅付费，解决地产物业电子收费，人工抄表、跑冒滴漏等经营管理问题。
            </div>
            <div>
                辰鳗自研的第三代人工智能终端通过无线通讯模组+MCU能耗算法模组的结合，不仅能解决地产物业经营管理催收催缴等问题，还能通过MCU能耗数据实时采集，为楼宇提供用能实时监测、能耗分析、对标、诊断、自控自检、公区分摊、用电安全故障、自动报警等AI全时段能源管理平台。
            </div>
            <div>
                通过能源管理平台，辰鳗为楼宇分析照明、动力、消防、空调、电梯等公区能耗问题。为楼宇提供暖通节能算法、智慧照明解决方案、电梯动力势能回馈、智能用水等节能产品服务，不仅降低楼宇人工巡检、催缴、线损等固有能耗成本，还为楼宇提供大功耗设备节能解决方案，真正为楼宇提供全生命周期AI能源管理服务。
            </div>
            <div>
                未来，辰鳗科技将聚焦能碳双管，需求侧能源高效利用、供给侧绿色能源替代两大方向， 加快构建基于城市建筑的可持续“零碳”之路。
            </div>
        </div>
        <p style="margin-top:40px">联系我们</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div class="detail" style="padding:10px 0">
            <div class="eachItem" style="margin-top:20px">
                <p>客服电话：</p><p>028-86533354</p>
            </div>
            <div class="eachItem">
                <p>客服时间：</p><p>09:00-18:00</p>
            </div>
            <div class="eachItem">
                <p>商业合作邮箱：</p><p style="word-break:break-all;">xiaomanguanjia@smalleel.com</p>
            </div>
            <div class="eachItem">
                <p>公司地址：</p><p>四川省成都市双流区电子科大科技园B12栋四单元4F-6F</p>
            </div>
        </div>
        <img src="../../../assets/phoneCloseCM/map.png" alt="" width='100%' style="margin:16px 0"/>
        <div class="erweima">
            <div><img src="../../../assets/phoneCloseCM/img1.png" alt="" width='70px'/><p>小鳗科技</p></div>
            <div><img src="../../../assets/phoneCloseCM/img2.png" alt="" width='70px'/><p>小鳗管家</p></div>
        </div>
    </div>
    <div class="article" v-if="activeIndex == 1">
        <img src="../../../assets/phoneCloseCM/Bg.png" alt=""  width='100%'>
    </div>
    <div class="article" v-if="activeIndex == 2">
        <p>知识产权</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>

        <div class="detail">
            <p style="margin-bottom:20px">高新技术企业证书</p>
            <div height="325px"  arrow="always">
                <div v-for="(item,index) in 1" :key="index" class="adjust">
                    <img :src="gximgpage" alt="" srcset="" width='80%'>
                    <p>
                        高新技术企业证书
                    </p>
                </div>
            </div>
        </div>

        <div class="detail">
            <p style="margin-bottom:20px">产品专利证书</p>
            <el-carousel height="325px"  arrow="always">
                <el-carousel-item v-for="(item,index) in cpzlData" :key="index" class="adjust">
                    <img :src="item.url" alt="" srcset="" width='50%'>
                    <p>
                        {{item.desc}}
                    </p>
                    <div>
                        {{item.desc1}}
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="detail">
            <p style="margin-bottom:20px">软件著作权</p>
            <el-carousel height="325px"  arrow="always">
                <el-carousel-item v-for="(item,index) in rjzzData" :key="index" class="adjust">
                    <img :src="item.url" alt="" srcset="" width='50%'>
                    <p>
                        {{item.desc}}
                    </p>
                    <div>
                        {{item.desc1}}
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="detail">
            <p style="margin-bottom:20px">产品型号证书</p>
            <el-carousel height="325px"  arrow="always">
                <el-carousel-item v-for="(item,index) in cpxhData" :key="index" class="adjust">
                    <img :src="item.url" alt="" srcset="" width='50%'>
                    <p>
                        {{item.desc}}
                    </p>
                    <div>
                        {{item.desc1}}
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="detail">
            <p style="margin-bottom:20px">质量管理证书</p>
            <el-carousel height="325px"  arrow="always">
                <el-carousel-item v-for="(item,index) in zlglData" :key="index" class="adjust">
                    <img :src="item.url" alt="" srcset="" width='50%'>
                    <p>
                        {{item.desc}}
                    </p>
                    <div>
                        {{item.desc1}}
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
    <div class="article" v-if="activeIndex == 3">
        <p>合作伙伴</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div class="detail" style="padding-bottom:50px">
            <img src="../../../assets/phoneCloseCM/pa.png" alt=""  width='100%'>
        </div>
    </div>
  </div>
</template>

<script>
import cpzl1 from '../../../assets/phoneCloseCM/cpzl/1.jpg'
import cpzl2 from '../../../assets/phoneCloseCM/cpzl/2.jpg'
import cpxh1 from '../../../assets/phoneCloseCM/cpxh/1.jpg'
import cpxh2 from '../../../assets/phoneCloseCM/cpxh/2.jpg'
import cpxh3 from '../../../assets/phoneCloseCM/cpxh/3.jpg'
import cpxh4 from '../../../assets/phoneCloseCM/cpxh/4.jpg'
import zlgl1 from '../../../assets/phoneCloseCM/zlgl/1.jpg'
import zlgl2 from '../../../assets/phoneCloseCM/zlgl/2.jpg'
import zlgl3 from '../../../assets/phoneCloseCM/zlgl/3.jpg'
import rjzz124 from '../../../assets/phoneCloseCM/rjzz/124.jpg'
import rjzz134 from '../../../assets/phoneCloseCM/rjzz/134.jpg'
import rjzz197 from '../../../assets/phoneCloseCM/rjzz/197.jpg'
import rjzz319 from '../../../assets/phoneCloseCM/rjzz/319.jpg'
import rjzz321 from '../../../assets/phoneCloseCM/rjzz/321.jpg'
import rjzz322 from '../../../assets/phoneCloseCM/rjzz/322.jpg'
import rjzz587 from '../../../assets/phoneCloseCM/rjzz/587.jpg'
import rjzz590 from '../../../assets/phoneCloseCM/rjzz/590.jpg'
import rjzz591 from '../../../assets/phoneCloseCM/rjzz/591.jpg'
import rjzz759 from '../../../assets/phoneCloseCM/rjzz/759.jpg'
import rjzz807 from '../../../assets/phoneCloseCM/rjzz/807.jpg'
import rjzz855 from '../../../assets/phoneCloseCM/rjzz/855.jpg'
import rjzz884 from '../../../assets/phoneCloseCM/rjzz/884.jpg'
import rjzz891 from '../../../assets/phoneCloseCM/rjzz/891.jpg'
import rjzz892 from '../../../assets/phoneCloseCM/rjzz/892.jpg'
import gximg from '../../../assets/service/gx.png'

export default {
    data() {
        return {
          gximgpage:gximg,
            tabs:[
                {name:'公司介绍',key:1,isActive:true},{name:'发展历程',key:2,isActive:false},{name:'知识产权',key:3,isActive:false},{name:'合作伙伴',key:4,isActive:false}
            ],
            activeIndex:0,
            cpzlData:[
                {url:cpzl2 , desc:'一种带有能耗异常告警的智能电表', desc1:"CN217587346U 实用新型"},
                {url:cpzl1 , desc:'一种带有防窃电功能的智能电表', desc1:"CN217587359U 实用新型"}
            ],
            cpxhData:[
                {url:cpxh1 , desc:'单相电子式电能表(导轨)', desc1:"DDSU6610"},
                {url:cpxh2 , desc:'单相电子式预付费电能表', desc1:"DDSY6610"},
                {url:cpxh3 , desc:'三相四线电子式电能表(导轨)',desc1:"DTSU6610"},
                {url:cpxh4 , desc:'三相四线电子式预付费电能表',desc1:"DTSY6610"},
            ],
            zlglData:[
                {url:zlgl1 , desc:'质量管理体系认证证书' , desc1:"41922Q00187-04R0S"},
                {url:zlgl2 , desc:'环境管理体系认证证书', desc1:"41922E00115-04R0S"},
                {url:zlgl3 , desc:'职业健康安全管理体系认证证书', desc1:"41922S00115-04R0S"},
            ],
            rjzzData:[
                {url:rjzz124 , desc:'小鳗智能设备实时能耗监测管控平台',desc1:"2022SR0667124"},
                {url:rjzz134 , desc:'小鳗物业系统',desc1:"2022SR0529134"},
                {url:rjzz197 , desc:'小鳗商户系统',desc1:"2022SR0525197"},
                {url:rjzz319 , desc:'小鳗平台管理系统',desc1:"2022SR0530319"},
                {url:rjzz321 , desc:'小鳗管家收费智能云平台',desc1:"2022SR0530321"},
                {url:rjzz322 , desc:'小鳗企业管理系统',desc1:"2022SR0530322"},
                {url:rjzz587 , desc:'小鳗智能设备终端信息交互控制管理系统',desc1:"2022SR0654587"},
                {url:rjzz590 , desc:'小鳗智能设备故障预警管理软件',desc1:"2022SR0654590"},
                {url:rjzz591 , desc:'小鳗智能设备能耗数据在线监测预警分析系统',desc1:"2022SR0654591"},
                {url:rjzz759 , desc:'小鳗智能设备定时控制系统',desc1:"2022SR0569759"},
                {url:rjzz807 , desc:'小鳗智能设备远程物联信息化管理软件',desc1:"2022SR0665807"},
                {url:rjzz855 , desc:'小鳗分润系统',desc1:"2022SR0569855"},
                {url:rjzz884 , desc:'小鳗智能设备数据监控采集系统',desc1:"2022SR0557884"},
                {url:rjzz891 , desc:'小鳗费用管理系统',desc1:"2022SR0569891"},
                {url:rjzz892 , desc:'小鳗开放平台系统',desc1:"2022SR0569892"},
            ],
            hideHeight:false
        }
    },
    methods:{
        changeActive(index){
            for (let i = 0; i < this.tabs.length; i++) {
                if(index == i){
                    this.tabs[i].isActive = true
                }else{
                    this.tabs[i].isActive = false
                }
            }
            this.activeIndex = index
        },
    },
    mounted(){
    window.onscroll=()=>{
      if(document.documentElement.scrollTop == 0 || document.body.scrollTop == 0 ){
          this.hideHeight = false
      }
      if(document.documentElement.scrollTop > 50 || document.body.scrollTop > 50 ){
          this.hideHeight = true
      }
  }
  },
}
</script>

<style lang="scss" scoped>
.mytabs{
    display: flex;
    justify-content: space-between;
    padding: 0 14px;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular;
    padding-top:19px;
    height: 50px;
    border-radius: 4px;
    width: 100%;
    position: fixed;
    left: 0;
    background-color: #24282E;
    z-index: 999;
}
.outerCtn{
    background-color: #24282E;
    color: white;
    min-height: 100vh;
    .article{
        margin: 40px 20px 0 20px;
        padding-bottom: 10px;
        padding-top: 60px;
        text-align: left;
        p{
            font-size: 20px;
            font-family: Alibaba PuHuiTi;
            font-weight: normal;
            padding-bottom: 10px;
            text-align: center;
            letter-spacing: 3px;
        }
        .imgCtn{
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          img{
            width:84px;
            height: 3px;
          }
        }
    }
    .detail{
        background-color: #2d2f33;
        margin-top: 20px;
        border-radius: 4px;
        overflow: hidden;
        padding: 26px 20px;
        padding-bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        div{
            font-size: 12px;
            margin-bottom: 20px;
            line-height: 20px;
            letter-spacing: 1px;
        }
        .eachItem{
            display: flex;
            padding-left: 20px;
            margin: 4px 0;
            p{
                font-size: 12px;
                padding-bottom: 0;
                text-align: left;
                text-indent:0cm;
                line-height: 20px;
                letter-spacing:1px
            }
        }
        .eachItem p:nth-child(2){
            max-width: 210px;
            color: #4A81FF;
        }
        .adjust{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            p{
                font-size:12px;
                margin-top:20px;
            }
        }
    }
    .erweima{
        display: flex;
        justify-content: space-around;
        width: 60%;
        margin: auto;
        p{
            font-size: 12px;
            margin-top: 12px;
            color: #3170FF;
        }
    }
}
</style>
<style>
    .detail .el-carousel__indicator--horizontal{
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/phone/phoneCloseCM.vue